import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/arrow_r.png';

const _withScopeId = n => (_pushScopeId("data-v-64658858"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "info-warp"
};
const _hoisted_3 = {
  class: "result"
};
const _hoisted_4 = {
  class: "header"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "year"
};
const _hoisted_7 = {
  class: "result-list"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "year"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "arrow"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));

const _hoisted_11 = {
  class: "result-info",
  "element-loading-background": "#fff"
};
const _hoisted_12 = {
  key: 1,
  style: {
    "display": "flex",
    "align-items": "center",
    "height": "100%"
  }
};
const _hoisted_13 = {
  key: 2
};
const _hoisted_14 = {
  class: "text-image-warp"
};
const _hoisted_15 = {
  class: "text-warp"
};
const _hoisted_16 = {
  class: "info-item"
};
const _hoisted_17 = {
  class: "label"
};
const _hoisted_18 = {
  class: "value"
};
const _hoisted_19 = {
  class: "info-item"
};
const _hoisted_20 = {
  class: "label"
};
const _hoisted_21 = {
  class: "value"
};
const _hoisted_22 = {
  class: "info-item"
};
const _hoisted_23 = {
  class: "label"
};
const _hoisted_24 = {
  class: "value"
};
const _hoisted_25 = {
  class: "info-item"
};
const _hoisted_26 = {
  class: "label"
};
const _hoisted_27 = {
  class: "value"
};
const _hoisted_28 = {
  class: "info-item"
};
const _hoisted_29 = {
  class: "label"
};
const _hoisted_30 = {
  class: "value"
};
const _hoisted_31 = {
  class: "info-item"
};
const _hoisted_32 = {
  class: "label"
};
const _hoisted_33 = {
  class: "value",
  style: {
    "flex-wrap": "wrap"
  }
};
const _hoisted_34 = {
  key: 0
};
const _hoisted_35 = {
  key: 0
};
const _hoisted_36 = {
  class: "image-warp"
};
const _hoisted_37 = ["src"];
const _hoisted_38 = {
  class: "info-item"
};
const _hoisted_39 = {
  class: "label"
};
const _hoisted_40 = {
  class: "value"
};
const _hoisted_41 = {
  class: "info-item"
};
const _hoisted_42 = {
  class: "label"
};
const _hoisted_43 = {
  class: "value"
};
const _hoisted_44 = {
  class: "info-item"
};
const _hoisted_45 = {
  class: "label"
};
const _hoisted_46 = {
  class: "value"
};
const _hoisted_47 = {
  class: "info-item"
};
const _hoisted_48 = {
  class: "label"
};
const _hoisted_49 = {
  class: "value"
};
const _hoisted_50 = {
  class: "info-item"
};
const _hoisted_51 = {
  class: "label"
};
const _hoisted_52 = {
  class: "value",
  style: {
    "flex-wrap": "wrap"
  }
};
const _hoisted_53 = {
  key: 0
};
const _hoisted_54 = {
  class: "info-item"
};
const _hoisted_55 = {
  class: "label"
};
const _hoisted_56 = {
  class: "value",
  style: {
    "flex-wrap": "wrap"
  }
};
const _hoisted_57 = {
  key: 0
};
const _hoisted_58 = {
  class: "info-item",
  style: {
    "border-bottom": "none"
  }
};
const _hoisted_59 = {
  class: "label"
};
const _hoisted_60 = {
  class: "value"
};
import SearchInput from '@/components/SearchInput/index.vue';
import { onMounted, nextTick } from 'vue';
import { debounce } from '@/utils/tools';
import { getTextWidth } from '@/utils'; // import { getScrollBarWidth } from 'element-plus/es/utils';

import { useI18n } from 'vue-i18n';
import { searchMovieApi, searchTvSeasonApi, getMovieDetailApi, getSeriesDetailApi } from '@/api/vodNew';
import { sourceIdOptions } from '@/assets/config/dicts.ts';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => {}
    },
    programType: {
      type: String,
      default: 'movie'
    }
  },

  setup(__props, {
    expose
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const searchInputRef = ref();
    const data = reactive({
      currentIndex: 0,
      resultListLoading: false,
      resultInfoLoading: false,
      resultList: [],
      detailMainInfo: null,
      detailInfo: null,
      page: 1,
      isMoreResultList: true
    }); // 搜索框配置

    const searchConfig = reactive({
      formData: {
        id: props.options.dialogOptions.infoId,
        language: 'en',
        keyWord: ''
      },
      formList: [{
        label: '信息源',
        prop: 'id',
        widgetType: 'Select',
        list: sourceIdOptions
      }, {
        label: '语言',
        prop: 'language',
        widgetType: 'Select',
        placeholder: '请选择语言',
        list: props.options.languageOptions,
        filterable: true
      }, {
        label: '关键字',
        prop: 'keyWord',
        widgetType: 'input',
        placeholder: '请输入关键字',
        require: true,
        rules: [{
          required: true,
          message: t('请输入关键字'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: t('限制字符数量', {
            num: 50
          }),
          trigger: 'blur'
        }]
      }]
    });
    watch(() => props.modelValue, val => {
      if (val) {
        nextTick(() => {
          getScroller();
        });
        data.currentIndex = 0; // 当前选中下标

        data.resultListLoading = false;
        data.resultInfoLoading = false;
        data.resultList = [];
        data.detailMainInfo = null;
        data.detailInfo = null;
        data.page = 1;
        data.isMoreResultList = true;
        searchConfig.formData = {
          id: props.options.dialogOptions.infoId,
          language: props.options.dialogOptions.language ? props.options.languageOptions.find(f => f.code == props.options.dialogOptions.language) && props.options.languageOptions.find(f => f.code == props.options.dialogOptions.language).value : props.options.languageOptions.find(f => !f.disabled).value,
          keyWord: ''
        };
      }
    }, {
      immediate: true,
      deep: true
    });

    const getResultLists = async isFirst => {
      data.resultListLoading = true;
      let params = {
        language: searchConfig.formData.language,
        name: searchConfig.formData.keyWord,
        pageNo: data.page,
        pageSize: 20,
        programType: props.programType,
        sourceName: props.options.dialogOptions.infoId
      };
      const res = props.programType === 'movie' ? await searchMovieApi(params) : await searchTvSeasonApi(params);

      if (res.code == '0') {
        if (!res.data || !res.data.length) {
          // 没有更多数据了
          data.isMoreResultList = false;
        }

        if (res.data === undefined) res.data = []; //防止res没有data导致报错

        data.resultList = props.options.dialogOptions.infoId === 'imdb' ? res.data : [...data.resultList, ...res.data];
      }

      if (isFirst && data.resultList.length > 0) {
        data.detailMainInfo = data.resultList[0];
        const id = data.resultList[0].id;

        if (id) {
          getResultInfo(id);
        }
      }

      data.resultListLoading = false;
    };

    const getResultInfo = async id => {
      data.resultInfoLoading = true;
      data.detailInfo = null;
      let params = {
        language: searchConfig.formData.language,
        videoId: id //programType: props.programType

      };
      let res = null;

      try {
        res = props.programType === 'movie' ? await getMovieDetailApi(params) : await getSeriesDetailApi(params);

        if (res.code == '0') {
          data.detailInfo = res.data;
        }
      } catch (error) {}

      data.resultInfoLoading = false;
    };

    const handleResultClick = debounce((item, index) => {
      data.detailMainInfo = item;
      data.currentIndex = index;
      console.log(item);
      const {
        id
      } = item;
      getResultInfo(id);
    }, 200); // 搜索事件

    const handleSearch = debounce(searchData => {
      searchInputRef.value.mForm.validate(valid => {
        if (valid) {
          props.options.dialogOptions.infoId = searchData.id;
          data.currentIndex = 0;
          data.page = 1;
          data.resultList = [];
          data.detailMainInfo = null;
          data.detailInfo = null;
          data.isMoreResultList = true;
          getResultLists(true);
        }
      });
    }, 200);

    const getScroller = () => {
      const scroller = document.querySelector('.result-list');
      scroller ? scroller.onscroll = e => {
        if (e.target.scrollHeight - e.target.clientHeight == e.target.scrollTop) {
          if (props.options.dialogOptions.infoId !== 'imdb' && !data.resultListLoading && data.isMoreResultList) {
            // console.log("到底了");
            data.page = data.page + 1;
            getResultLists(false);
          }
        }
      } : '';
    };

    onMounted(() => {
      getScroller();
    }); //  内容超出时显示提示

    const tipDisabled = ref(false);

    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(target.innerText);
      tipDisabled.value = target.offsetWidth < width;
    };

    expose({
      data,
      searchConfig
    });

    const handleReset = formData => {
      data.currentIndex = 0;
      data.page = 1;
      data.resultList = [];
      data.detailMainInfo = null;
      data.detailInfo = null;
      searchConfig.formData = {
        id: props.options.dialogOptions.infoId,
        language: props.options.dialogOptions.language ? props.options.languageOptions.find(f => f.label == props.options.dialogOptions.language) && props.options.languageOptions.find(f => f.label == props.options.dialogOptions.language).value : props.options.languageOptions.find(f => !f.disabled).value,
        keyWord: ''
      };
    };

    return (_ctx, _cache) => {
      const _component_MPopper = _resolveComponent("MPopper");

      const _component_el_empty = _resolveComponent("el-empty");

      const _directive_loading = _resolveDirective("loading");

      return __props.modelValue ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(SearchInput, {
        labelWidth: "120px",
        ref_key: "searchInputRef",
        ref: searchInputRef,
        class: "search-input",
        size: {
          sm: 12,
          md: 12,
          lg: 8,
          xl: 6,
          xs: 24
        },
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: _unref(handleSearch),
        onReset: handleReset
      }, null, 8, ["form-list", "form-data", "onSearch"]), _createElementVNode("div", _hoisted_2, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('搜索结果')), 1), _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('年份')), 1)]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.resultList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["result-item", data.currentIndex === index ? 'is-selected' : '']),
          onClick: $event => _unref(handleResultClick)(item, index),
          key: index
        }, [_createVNode(_component_MPopper, {
          disabled: tipDisabled.value,
          placement: "top",
          trigger: "hover",
          content: item.name
        }, {
          reference: _withCtx(() => [_createElementVNode("span", {
            onMouseover: showTextTip,
            class: "title"
          }, _toDisplayString(item.name), 33)]),
          _: 2
        }, 1032, ["disabled", "content"]), _createElementVNode("span", _hoisted_9, _toDisplayString(item.year), 1)], 10, _hoisted_8);
      }), 128)), data.resultList.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 0,
        style: {
          "display": "flex",
          "align-items": "center",
          "height": "100%"
        }
      })) : _createCommentVNode("", true)])])), [[_directive_loading, data.resultListLoading]]), _hoisted_10, _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [!data.detailInfo && !data.resultInfoLoading ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 0,
        style: {
          "display": "flex",
          "align-items": "center",
          "height": "100%"
        }
      })) : _createCommentVNode("", true), data.resultInfoLoading ? (_openBlock(), _createElementBlock("div", _hoisted_12)) : _createCommentVNode("", true), data.detailInfo && !data.resultInfoLoading ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('信息源ID')), 1), _createElementVNode("span", _hoisted_18, _toDisplayString(data.detailMainInfo.id), 1)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('名称')), 1), _createElementVNode("span", _hoisted_21, _toDisplayString(data.detailMainInfo.name), 1)]), _createElementVNode("div", _hoisted_22, [_createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('年份')), 1), _createElementVNode("span", _hoisted_24, _toDisplayString(data.detailMainInfo.year), 1)]), _createElementVNode("div", _hoisted_25, [_createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('国家')), 1), _createElementVNode("span", _hoisted_27, _toDisplayString(data.detailInfo.country), 1)]), _createElementVNode("div", _hoisted_28, [_createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('影片时长')), 1), _createElementVNode("span", _hoisted_30, _toDisplayString(data.detailInfo.length), 1)]), _createElementVNode("div", _hoisted_31, [_createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('分类属性')), 1), _createElementVNode("span", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.detailInfo.genres, (item, index) => {
        return _openBlock(), _createElementBlock("span", null, [item.name ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode(_toDisplayString(item.name) + " ", 1), index != data.detailInfo.genres.length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_34, " ,")) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode(_toDisplayString(item) + " ", 1), index != data.detailInfo.genres.length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_35, " ,")) : _createCommentVNode("", true)], 64))]);
      }), 256))])])]), _createElementVNode("div", _hoisted_36, [_createElementVNode("img", {
        src: data.detailInfo.posterUrl,
        alt: ""
      }, null, 8, _hoisted_37)])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_38, [_createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('上映时间')), 1), _createElementVNode("span", _hoisted_40, _toDisplayString(data.detailInfo.releaseDate), 1)]), _createElementVNode("div", _hoisted_41, [_createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t('预告片')), 1), _createElementVNode("span", _hoisted_43, _toDisplayString(data.detailInfo.sourceId), 1)]), _createElementVNode("div", _hoisted_44, [_createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('评分')), 1), _createElementVNode("span", _hoisted_46, _toDisplayString(data.detailInfo.rating), 1)]), _createElementVNode("div", _hoisted_47, [_createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$t('认证')), 1), _createElementVNode("span", _hoisted_49, _toDisplayString(data.detailInfo.certification), 1)]), _createElementVNode("div", _hoisted_50, [_createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$t('导演')), 1), _createElementVNode("span", _hoisted_52, [data.detailInfo.director ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(data.detailInfo.director || [], (item, index) => {
        return _openBlock(), _createElementBlock("span", null, [_createTextVNode(_toDisplayString(item.name) + " ", 1), data.detailInfo.director && index != data.detailInfo.length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_53, " ,")) : _createCommentVNode("", true)]);
      }), 256)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_54, [_createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t('演员')), 1), _createElementVNode("span", _hoisted_56, [data.detailInfo.actor ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(data.detailInfo.actor || [], (item, index) => {
        return _openBlock(), _createElementBlock("span", null, [_createTextVNode(_toDisplayString(item.name) + " ", 1), data.detailInfo.actor && index != data.detailInfo.actor.length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_57, " ,")) : _createCommentVNode("", true)]);
      }), 256)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_58, [_createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t('描述')), 1), _createElementVNode("span", _hoisted_60, _toDisplayString(data.detailInfo.description), 1)])])])) : _createCommentVNode("", true)])), [[_directive_loading, data.resultInfoLoading]])])])) : _createCommentVNode("", true);
    };
  }

});